import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=40450fcd&scoped=true&"
import script from "./Certification.vue?vue&type=script&lang=ts&"
export * from "./Certification.vue?vue&type=script&lang=ts&"
import style0 from "./Certification.vue?vue&type=style&index=0&id=40450fcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40450fcd",
  null
  
)

export default component.exports